module.exports = __webpack_public_path__ + "static/fonts/Mont-Black.98fcfaa.woff";